import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import sendRequest from "../../../helpers/requestHelper";

const getProjectTasks = {
    namespaced: true,
    state: {
        pagination: {
            page: 1,
            rowsPerPage: 20,
            totalItems: null,
            sortBy: [""],
            sortDesc: [""],
            current: 1
        },
        loadingTasks: false,
        dataReceive: []
    },
    mutations: {
        GET_PROJECT_TASKS_SUCCESS(state, response) {
            state.dataReceive = response.data.data;
            if(response.data.meta !== undefined) {
                state.pagination.page = response.data.meta.current_page;
                state.pagination.rowsPerPage = response.data.meta.per_page;
                state.pagination.totalItems = response.data.meta.total;
            }
            state.loadingTasks = false;
            eventBus.$emit("getTasksSuccess", state.dataReceive);
        },
        GET_PROJECT_TASKS_FAILURE(state, error) {
            state.loadingTasks = false;
            console.log(error);
        }
    },
    actions: {
        getProjectTasks: function({ dispatch, state }, page = {}) {
            let queryParams = {};
            if(page.valueSearch !== undefined) {
                let page_number = page.valueSearch.page || state.pagination.page;
                let rowsPerPage = page.valueSearch.itemsPerPage || state.pagination.rowsPerPage;
                let sortDesc = page.valueSearch.sortDesc || state.pagination.sortDesc;
                let sortBy = (page.valueSearch.sortBy !== undefined && page.valueSearch.sortBy.length !== 0) ? page.valueSearch.sortBy : state.pagination.sortBy;
                let language = page.valueSearch.language;
                let current_page = page.valueSearch.filters === true ? 1 : null;
                let search = page.valueSearch.search === 3 ? null : page.valueSearch.search;

                let url = new URL(window.location.href);

                let projectId = url.searchParams.get("id");
                
                queryParams = {
                    page: page_number,
                    rowsPerPage: rowsPerPage,
                    language,
                    sortBy: sortBy[0],
                    sortDesc: sortDesc[0],
                    current_page,
                    projectId
                }

                if (search || search === 0) {
                    queryParams.search = search
                }

                state.pagination.sortBy = sortBy;
                state.pagination.sortDesc = sortDesc;
            }
            let contactsUrl = config.baseURLApi + "/project-tasks";
            let promise = sendRequest("get", contactsUrl, {}, {}, true, queryParams);
            eventBus.$emit("setDisablePagination", true);
            state.loadingTasks = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetTasks", result[1]);
                } else {
                    dispatch("failureGetTasks", result[1]);
                }
                eventBus.$emit("setDisablePagination", false);

            })
        },
        successGetTasks: function({ commit }, response) {
            commit("GET_PROJECT_TASKS_SUCCESS", response);
        },
        failureGetTasks: function({ commit }, error) {
            commit("GET_PROJECT_TASKS_FAILURE", error);
        }
    }
}

export default getProjectTasks;